import React from "react";
import PassThruACHPage from "components/pages/PassThruACHPage";

export default function CaptureACHPassThru(props) {
  return (
    <PassThruACHPage />
  )
}
